<template></template>

<script>
import * as XLSX from 'xlsx'
import { getFullAddress } from '@/utils/common'

export default {
  name: 'ExportToExcel',
  props: {
    employeeData: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      reporteeChain: this.$storage.getUniversal('userReporteeChain'),
      orgLang: this.$store.state.orgLanguage
    }
  },
  computed: {
    orgLanguage() {
      return this.orgLang.data.leftNav
    }
  },
  methods: {
    exportToExcel() {
      let serialNumber = 1
      const maxManagerLevels = Math.max(
        ...this.employeeData.map(
          (employee) =>
            (this.reporteeChain[employee.empId]?.managerChain?.split(' -> ') || []).length
        ),
        0
      )
      const exportData = this.employeeData.flatMap((employee) => {
        if (!employee.locationData || employee.locationData.length === 0) {
          return []
        }
        const dateVisits = employee.locationData.reduce((acc, location) => {
          if (!location.travelDate) return acc
          const travelDate = this.$dayjs(location.travelDate).format('DD/MM/YYYY')
          if (!acc[travelDate]) {
            acc[travelDate] = []
          }
          acc[travelDate].push(location)
          return acc
        }, {})

        const managerList = this.reporteeChain[employee.empId]?.managerChain?.split(' -> ') || []

        // Dynamically create manager columns
        let managerColumns = {}
        for (let i = 0; i < maxManagerLevels; i++) {
          managerColumns[`Manager Level ${i + 1}`] = managerList[i] || ''
        }
        const employeeEntries = Object.keys(dateVisits)
          ?.flatMap((date) => {
            const visits = dateVisits[date]
            if (!visits || visits.length === 0) return []
            const totalVisits = visits?.reduce((count, visit) => {
              const visitCount = visit.locationData.filter(
                (loc) =>
                  loc.activity.caseTaskDetails?.actualStartDateTime &&
                  loc.activity.action === 'taskEnded'
              ).length
              return count + visitCount
            }, 0)

            let isFirstEntryForDate = true

            return visits?.flatMap((visit) => {
              const visitTimeDetails = visit.locationData
                ?.filter(
                  (loc) => loc.activity.action === 'checkIn' || loc.activity.action === 'taskEnded'
                )
                ?.map((loc) => ({
                  caseNo: loc.activity.caseTaskDetails?.case?.caseNo,
                  meetingOutCome: loc.activity.caseTaskDetails
                    ? loc.activity.caseTaskDetails?.meetingDetails?.meetingOutCome
                    : '',
                  visitTime: loc.activity.caseTaskDetails
                    ? this.$dayjs(loc.activity.caseTaskDetails?.actualStartDateTime).format(
                        'DD/MM/YYYY HH:mm A'
                      )
                    : '',
                  visitAddress: loc.activity.caseTaskDetails ? loc.location?.formatted_address : '',
                  customerName: loc.activity?.caseTaskDetails?.case?.customer?.customerFullName,
                  companyName: loc.activity?.taskDetails?.leadDetails?.company?.name,
                  customerAddress: loc.activity.caseTaskDetails?.case?.customer?.customerAddress
                    ?.length
                    ? getFullAddress(
                        loc.activity.caseTaskDetails?.case?.customer?.customerAddress[0]
                      )
                    : '',
                  visitCount: 1
                }))
              if (!visitTimeDetails || visitTimeDetails.length === 0) {
                return []
              }

              return visitTimeDetails?.map((detail) => {
                const entry = {
                  'S.No': date ? serialNumber : '',
                  'Travel Date': date,
                  [`${this.orgLanguage?.employees || 'Employee'} Name`]: employee.fullName || '',
                  [`${this.orgLanguage?.employees || 'Employee'} Id`]: employee.employeeId || '',
                  [`${this.orgLanguage?.employees || 'Employee'} Role`]: employee.empRole || '',
                  [`${this.orgLanguage?.employees || 'Employee'} Designation`]:
                    employee.designation || '',
                  [`${this.orgLanguage?.employees || 'Employee'} City`]: employee.empCity || '',
                  ...managerColumns,
                  'Manager Hierarchy': this.reporteeChain[employee.empId]?.managerChain || '',
                  'Branch Name': employee?.branch || '',
                  'Case Number': detail.caseNo || '-',
                  'Case Outcome Status': detail.meetingOutCome,
                  'Visit Date/Time': detail.visitTime || '-',
                  'Visit start/ Clock-In address': detail.visitAddress || '',
                  'Customer Name': detail.customerName || detail.companyName || '-',
                  'Customer Address': detail.customerAddress || '-',
                  'Total Visits': isFirstEntryForDate
                    ? `Total visit by ${employee.fullName} on ${date} - (${totalVisits})`
                    : '',
                  Distance: isFirstEntryForDate ? visit.dailyDistanceTraveled.distance : '',

                  'Total Count': isFirstEntryForDate ? totalVisits : ''
                }

                if (date) {
                  serialNumber++
                }

                if (isFirstEntryForDate) {
                  isFirstEntryForDate = false
                }

                return entry
              })
            })
          })
          .filter((entry) => Object.values(entry).some((value) => value))

        if (!employeeEntries || employeeEntries.length === 0) {
          return []
        }

        return employeeEntries
      })

      const ws = XLSX.utils.json_to_sheet(exportData)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Employee Data')

      XLSX.writeFile(wb, 'Employee_Visit_Data.xlsx')
    }
  },
  mounted() {
    this.$root.$on('export-daily-excel', this.exportToExcel)
  },
  beforeDestroy() {
    this.$root.$off('export-daily-excel', this.exportToExcel)
  }
}
</script>
